import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

// https://mui.com/components/icons/#createsvgicon
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MyBusiness = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M16 10C16 9.58579 16.3358 9.25 16.75 9.25H20.5C20.9142 9.25 21.25 9.58579 21.25 10V21.25C21.25 21.6642 20.9142 22 20.5 22H16.75C16.3358 22 16 21.6642 16 21.25V10ZM17.5 10.75V20.5H19.75V10.75H17.5ZM8.5 13C8.5 12.5858 8.83579 12.25 9.25 12.25H13C13.4142 12.25 13.75 12.5858 13.75 13V21.25C13.75 21.6642 13.4142 22 13 22H9.25C8.83579 22 8.5 21.6642 8.5 21.25V13ZM10 13.75V20.5H12.25V13.75H10ZM1 16C1 15.5858 1.33579 15.25 1.75 15.25H5.5C5.91421 15.25 6.25 15.5858 6.25 16V21.25C6.25 21.6642 5.91421 22 5.5 22H1.75C1.33579 22 1 21.6642 1 21.25V16ZM2.5 16.75V20.5H4.75V16.75H2.5Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M2.5 20.5V16.75H4.75V20.5H2.5Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10 20.5V13.75H12.25V20.5H10Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.5 20.5V10.75H19.75V20.5H17.5Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M17.5001 1.75C17.5001 1.33579 17.8359 1 18.2501 1H21.2501C21.6644 1 22.0001 1.33579 22.0001 1.75V4.75C22.0001 5.16421 21.6644 5.5 21.2501 5.5C20.8359 5.5 20.5001 5.16421 20.5001 4.75V3.42013L14.9984 8.31056C14.7496 8.53169 14.3849 8.56241 14.1026 8.386L8.47772 4.87042L2.11437 8.40562C1.75228 8.60678 1.29568 8.47632 1.09452 8.11423C0.893359 7.75214 1.02382 7.29554 1.3859 7.09438L8.1359 3.34438C8.37447 3.21184 8.66621 3.21936 8.89764 3.364L14.4215 6.81642L19.2775 2.5H18.2501C17.8359 2.5 17.5001 2.16421 17.5001 1.75Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  })]
}), 'MyBusiness');
export var MyBusinessHover = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M16 10C16 9.58579 16.3358 9.25 16.75 9.25H20.5C20.9142 9.25 21.25 9.58579 21.25 10V21.25C21.25 21.6642 20.9142 22 20.5 22H16.75C16.3358 22 16 21.6642 16 21.25V10ZM17.5 10.75V20.5H19.75V10.75H17.5ZM8.5 13C8.5 12.5858 8.83579 12.25 9.25 12.25H13C13.4142 12.25 13.75 12.5858 13.75 13V21.25C13.75 21.6642 13.4142 22 13 22H9.25C8.83579 22 8.5 21.6642 8.5 21.25V13ZM10 13.75V20.5H12.25V13.75H10ZM1 16C1 15.5858 1.33579 15.25 1.75 15.25H5.5C5.91421 15.25 6.25 15.5858 6.25 16V21.25C6.25 21.6642 5.91421 22 5.5 22H1.75C1.33579 22 1 21.6642 1 21.25V16ZM2.5 16.75V20.5H4.75V16.75H2.5Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M2.5 20.5V16.75H4.75V20.5H2.5Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10 20.5V13.75H12.25V20.5H10Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.5 20.5V10.75H19.75V20.5H17.5Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M17.5001 1.75C17.5001 1.33579 17.8359 1 18.2501 1H21.2501C21.6644 1 22.0001 1.33579 22.0001 1.75V4.75C22.0001 5.16421 21.6644 5.5 21.2501 5.5C20.8359 5.5 20.5001 5.16421 20.5001 4.75V3.42013L14.9984 8.31056C14.7496 8.53169 14.3849 8.56241 14.1026 8.386L8.47772 4.87042L2.11437 8.40562C1.75228 8.60678 1.29568 8.47632 1.09452 8.11423C0.893359 7.75214 1.02382 7.29554 1.3859 7.09438L8.1359 3.34438C8.37447 3.21184 8.66621 3.21936 8.89764 3.364L14.4215 6.81642L19.2775 2.5H18.2501C17.8359 2.5 17.5001 2.16421 17.5001 1.75Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  })]
}), 'MyBusinessHover');
export var MyBusinessFilled = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M16 10C16 9.58579 16.3358 9.25 16.75 9.25H20.5C20.9142 9.25 21.25 9.58579 21.25 10V21.25C21.25 21.6642 20.9142 22 20.5 22H16.75C16.3358 22 16 21.6642 16 21.25V10ZM17.5 10.75V20.5H19.75V10.75H17.5ZM8.5 13C8.5 12.5858 8.83579 12.25 9.25 12.25H13C13.4142 12.25 13.75 12.5858 13.75 13V21.25C13.75 21.6642 13.4142 22 13 22H9.25C8.83579 22 8.5 21.6642 8.5 21.25V13ZM10 13.75V20.5H12.25V13.75H10ZM1 16C1 15.5858 1.33579 15.25 1.75 15.25H5.5C5.91421 15.25 6.25 15.5858 6.25 16V21.25C6.25 21.6642 5.91421 22 5.5 22H1.75C1.33579 22 1 21.6642 1 21.25V16ZM2.5 16.75V20.5H4.75V16.75H2.5Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M2.5 20.5V16.75H4.75V20.5H2.5Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10 20.5V13.75H12.25V20.5H10Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.5 20.5V10.75H19.75V20.5H17.5Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M17.5001 1.75C17.5001 1.33579 17.8359 1 18.2501 1H21.2501C21.6644 1 22.0001 1.33579 22.0001 1.75V4.75C22.0001 5.16421 21.6644 5.5 21.2501 5.5C20.8359 5.5 20.5001 5.16421 20.5001 4.75V3.42013L14.9984 8.31056C14.7496 8.53169 14.3849 8.56241 14.1026 8.386L8.47772 4.87042L2.11437 8.40562C1.75228 8.60678 1.29568 8.47632 1.09452 8.11423C0.893359 7.75214 1.02382 7.29554 1.3859 7.09438L8.1359 3.34438C8.37447 3.21184 8.66621 3.21936 8.89764 3.364L14.4215 6.81642L19.2775 2.5H18.2501C17.8359 2.5 17.5001 2.16421 17.5001 1.75Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  })]
}), 'MyBusinessFilled');